import React from "react";
// import {EditorWidget} from "@rsharma9650powerserv/template-editor";
// redux
import { Provider } from 'react-redux';
import store from './store';

import PricingContent from './PricingContent';
const Pricing = () => {

  return (
    <Provider store={store}>
      <PricingContent className="ranking-module"></PricingContent>
      {/* <EditorWidget
      config={{
          apiKey: "5ae0dee2-8c6a-4de8-92b7-a4cee63641c4",
          clientId: "193278a865274a369388267933cab54e",
          productId: "1",
          // enerexIdentifier: "DAAE65EB-E970-4CA6-87B4-3F27F38D50F5",
        }}
      ></EditorWidget> */}
    </Provider>
  );
};

export default Pricing;
